export default __webpack_public_path__ + "static/media/h02.9bbeb463.svg";